import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=c56eee1c&scoped=true"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"
import style0 from "./ModelList.vue?vue&type=style&index=0&id=c56eee1c&prod&lang=css"
import style1 from "./ModelList.vue?vue&type=style&index=1&id=c56eee1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56eee1c",
  null
  
)

export default component.exports